import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import { useTranslation } from 'react-i18next';
import MundRedRock from '../icons/MundRedRock';
import RedRockIcon from '../icons/RedRock';

export default function RedRock() {
  const { t } = useTranslation('integration');

  return (
    <IntegrationTable
      integrationKey='red_rock'
      title='RedRock'
      main_icon={<MundRedRock />}
      icon={<RedRockIcon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.secret_token,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        active_statuses: ['paid'],
      }}
      fieldLabels={{
        access_token: t('red_rock_client_id'),
        placeholder_access_token: t('red_rock_client_id_placeholder'),
        secret_token: t('red_rock_client_secret'),
        placeholder_secret_token: t('red_rock_client_secret_placeholder'),
      }}
    />
  );
}
